var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, Directive } from "@angular/core";
import { OompaLoompa } from "../../../utils/chocolate/oompa-loompa";
import { RowActionService } from "../providers/row-action-service";
import { DatagridWillyWonka } from "./datagrid-willy-wonka";
var ActionableOompaLoompa = (function (_super) {
    __extends(ActionableOompaLoompa, _super);
    function ActionableOompaLoompa(cdr, willyWonka, rowActions) {
        var _this = _super.call(this, cdr, willyWonka) || this;
        _this.rowActions = rowActions;
        return _this;
    }
    Object.defineProperty(ActionableOompaLoompa.prototype, "flavor", {
        get: function () {
            return this.rowActions.hasActionableRow;
        },
        enumerable: true,
        configurable: true
    });
    return ActionableOompaLoompa;
}(OompaLoompa));
export { ActionableOompaLoompa };
ActionableOompaLoompa.decorators = [
    { type: Directive, args: [{
                selector: "clr-datagrid, clr-dg-row"
            },] },
];
/** @nocollapse */
ActionableOompaLoompa.ctorParameters = function () { return [
    { type: ChangeDetectorRef, },
    { type: DatagridWillyWonka, },
    { type: RowActionService, },
]; };
//# sourceMappingURL=actionable-oompa-loompa.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/chocolate/actionable-oompa-loompa.js
// module id = 286
// module chunks = 4